module.exports = __webpack_public_path__ + "img/Mail-notification.aa8f53a0.svg";